import { MutableData } from '@polymer/polymer/lib/mixins/mutable-data.js';
import { html } from '../../../mixins/katapult-element.js';
import { KatapultModelEditorElement } from '../katapult-editor-template.js';
import { PortalStyle } from '../katapult-model-editor-style.js';
import '@polymer/paper-radio-group/paper-radio-group.js';
import '@polymer/paper-radio-button/paper-radio-button.js';
import '@polymer/paper-input/paper-input.js';
import '../../paper-table/paper-table.js';
import '../../material-icon/material-icon.js';
import '../../katapult-drop-down/katapult-drop-down.js';
import '../../k-logic-editor/k-logic-editor.js';
import '../../input-element/input-element.js';
import '../../katapult-switcher/katapult-switcher.js';
import '../../katapult-elements/katapult-button.js';
import '../../style-modules/paper-table-style.js';
import { DEFAULT_SCHEMAS, PORTAL_SCHEMAS } from '../../../modules/KLogicSchemas.js';
import { GeneratePushID } from '../../../modules/GeneratePushID.js';

import './workflow-action-email-template.js';

customElements.define(
  'workflow-action-editor',
  class extends MutableData(KatapultModelEditorElement) {
    static get template() {
      return html`
        <!-- Style -->
        ${PortalStyle}
        <style>
          :host {
            display: flex;
            flex-direction: column;
          }

          :host() > paper-row > paper-cell:nth-child(-n + 2) {
            font-weight: 500;
            color: var(--primary-text-color-faded);
          }

          .input-note {
            font-size: 11pt;
            font-style: italic;
          }
        </style>

        <!-- SET_STATUS -->
        <template is="dom-if" if="[[equal(item.action, 'SET_STATUS')]]" restamp>
          <!-- App Status -->
          <paper-row input>
            <paper-cell icon>
              <material-icon icon="list"></material-icon>
            </paper-cell>
            <paper-cell shrink>Status</paper-cell>
            <paper-cell>
              <katapult-drop-down
                label="Status"
                value="[[item.status]]"
                value-path="$key"
                label-path="name"
                items="[[appType.statuses]]"
                no-label-float
                data-path="item.status"
                on-selected-changed="updateProperty"
              >
              </katapult-drop-down>
            </paper-cell>
            <paper-cell italic>What status should the application be set to?</paper-cell>
          </paper-row>
        </template>

        <!-- SET_METADATA -->
        <template is="dom-if" if="[[equal(item.action, 'SET_METADATA')]]" restamp>
          <!-- Attribute -->
          <paper-row input>
            <paper-cell icon>
              <material-icon icon="list"></material-icon>
            </paper-cell>
            <paper-cell shrink>Attribute</paper-cell>
            <paper-cell>
              <katapult-drop-down
                label="Attribute"
                value="[[item.attribute]]"
                value-path="$key"
                label-path="$key"
                label-function="[[camelCase]]"
                items="[[otherAttributes]]"
                filter="[[_isJobAttribute]]"
                no-label-float
                data-path="item.attribute"
                on-selected-changed="updateProperty"
              ></katapult-drop-down>
            </paper-cell>
          </paper-row>
          <!-- Default Value -->
          <paper-row input expand>
            <paper-cell icon>
              <material-icon icon="input"></material-icon>
            </paper-cell>
            <paper-cell shrink>Value</paper-cell>
            <paper-cell>
              <template is="dom-if" if="[[equal(attributeInputEditor, 'k-logic-editor')]]" restamp>
                <k-logic-editor
                  block="[[item.value]]"
                  schema="[[_klogicSchemas.setMetadata]]"
                  data-path="item.value"
                  on-block-changed="updateProperty"
                ></k-logic-editor>
              </template>
              <template is="dom-if" if="[[equal(attributeInputEditor, 'input-element')]]" restamp>
                <input-element
                  grow
                  no-label-float
                  hide-attribute-name
                  camel-case
                  attribute_name="[[item.attribute]]"
                  model="[[getAttributeModel(item.attribute, otherAttributes)]]"
                  other-attributes="[[otherAttributes]]"
                  user-group="[[userGroup]]"
                  value="[[item.value]]"
                  data-path="item.value"
                  on-input-element-change="updateProperty"
                  job-creator="[[modelSpaceDetails.$key]]"
                ></input-element>
              </template>
            </paper-cell>
          </paper-row>
        </template>

        <!-- SET_TIMER -->
        <template is="dom-if" if="[[equal(item.action, 'SET_TIMER')]]" restamp>
          <!-- Timer -->
          <paper-row input>
            <paper-cell icon>
              <material-icon icon="timer"></material-icon>
            </paper-cell>
            <paper-cell shrink>Timer</paper-cell>
            <paper-cell>
              <katapult-drop-down
                label="Timer"
                value="[[item.timer]]"
                value-path="$key"
                label-path="name"
                items="[[appType.timers]]"
                no-label-float
                data-path="item.timer"
                on-selected-changed="updateProperty"
              ></katapult-drop-down>
            </paper-cell>
            <paper-cell italic>Which timer should be set?</paper-cell>
          </paper-row>
        </template>

        <!-- SET_TIMER_LENGTH -->
        <template is="dom-if" if="[[equal(item.action, 'SET_TIMER_LENGTH')]]" restamp>
          <!-- Timer -->
          <paper-row input>
            <paper-cell icon>
              <material-icon icon="timer"></material-icon>
            </paper-cell>
            <paper-cell shrink>Timer</paper-cell>
            <paper-cell>
              <katapult-drop-down
                label="Timer"
                value="[[item.timer]]"
                value-path="$key"
                label-path="name"
                items="[[appType.timers]]"
                no-label-float
                data-path="item.timer"
                on-selected-changed="updateProperty"
              ></katapult-drop-down>
            </paper-cell>
            <paper-cell italic>Which timer's length should be set?</paper-cell>
          </paper-row>
          <!-- Length -->
          <paper-row input>
            <paper-cell icon>
              <material-icon icon="date_range"></material-icon>
            </paper-cell>
            <paper-cell shrink>Length</paper-cell>
            <paper-cell class="timerLength">
              <paper-input
                type="number"
                label="Length"
                value="[[item.length]]"
                data-path="item.length"
                no-label-float
                underline
                on-value-changed="updateProperty"
              >
                <span slot="suffix">days</span>
              </paper-input>
            </paper-cell>
          </paper-row>
        </template>

        <!-- CLEAR_TIMER -->
        <template is="dom-if" if="[[equal(item.action, 'CLEAR_TIMER')]]" restamp>
          <!-- Timer -->
          <paper-row input>
            <paper-cell icon>
              <material-icon icon="timer"></material-icon>
            </paper-cell>
            <paper-cell shrink>Timer</paper-cell>
            <paper-cell>
              <katapult-drop-down
                label="Timer"
                value="[[item.timer]]"
                value-path="$key"
                label-path="name"
                items="[[appType.timers]]"
                no-label-float
                data-path="item.timer"
                on-selected-changed="updateProperty"
              ></katapult-drop-down>
            </paper-cell>
            <paper-cell italic>Which timer should be cleared?</paper-cell>
          </paper-row>
        </template>

        <!-- SET_UNIQUE_ID -->
        <template is="dom-if" if="[[equal(item.action, 'SET_APP_NUMBER')]]" restamp>
          <paper-row input>
            <paper-cell icon>
              <material-icon icon="badge"></material-icon>
            </paper-cell>
            <paper-cell shrink>Generation Method</paper-cell>
            <paper-cell>
              <paper-radio-group
                selected="[[item.generation_method]]"
                data-path="item.generation_method"
                on-selected-changed="updateProperty"
              >
                <paper-radio-button name="use_default_identifier">Use Default Identifier (APP_######)</paper-radio-button>
                <paper-radio-button name="use_custom_logic">Use Custom Logic</paper-radio-button>
              </paper-radio-group>
            </paper-cell>
          </paper-row>
          <template is="dom-if" if="[[equal(item.generation_method, 'use_custom_logic')]]" restamp>
            <paper-row input expand>
              <paper-cell icon>
                <material-icon icon="input"></material-icon>
              </paper-cell>
              <paper-cell shrink>Generation Logic</paper-cell>
            </paper-row>
            <paper-row>
              <paper-cell icon></paper-cell>
              <paper-cell>
                <span style="font-size: 11pt"
                  >Warning: the output of this logic statement must be unique. Advancing this Workflow Status will fail if another job with
                  the same name already exists.</span
                >
              </paper-cell>
            </paper-row>
            <paper-row input expand>
              <paper-cell icon></paper-cell>
              <paper-cell>
                <k-logic-editor
                  block="[[item.generation_logic]]"
                  schema="[[_klogicSchemas.setMetadata]]"
                  data-path="item.generation_logic"
                  on-block-changed="updateProperty"
                ></k-logic-editor>
              </paper-cell>
            </paper-row>
          </template>
        </template>

        <!-- GENERATE_EXPORT -->
        <template is="dom-if" if="[[equal(item.action, 'GENERATE_EXPORT')]]" restamp>
          <!-- Export -->
          <paper-row input>
            <paper-cell icon>
              <material-icon icon="analytics"></material-icon>
            </paper-cell>
            <paper-cell shrink>Export</paper-cell>
            <paper-cell>
              <katapult-drop-down
                label="Export"
                value="[[item.export]]"
                value-path="$key"
                label-path="name"
                items="[[exportOptions]]"
                no-label-float
                data-path="item.export"
                on-selected-changed="updateProperty"
              ></katapult-drop-down>
            </paper-cell>
          </paper-row>
        </template>

        <!-- SEND_EMAIL -->
        <template is="dom-if" if="[[equal(item.action, 'SEND_EMAIL')]]" restamp>
          <workflow-action-email-template
            template="[[item.email_template]]"
            data-path="item.email_template"
            on-template-changed="updateProperty"
          ></workflow-action-email-template>
        </template>

        <!-- SHARE_APP -->
        <template is="dom-if" if="[[equal(item.action, 'SHARE_APP')]]" restamp>
          <!-- Share With -->
          <paper-row expand>
            <paper-cell icon>
              <katapult-icon icon="share"></katapult-icon>
            </paper-cell>
            <paper-cell shrink>Share With</paper-cell>
            <paper-cell>
              <paper-table rounded white outline grow overflow-hidden dividers style="width: 600px;">
                <!-- Body -->
                <template is="dom-repeat" items="[[getItemsArray(item.sharing_changes.*)]]" as="changeItem" mutable-data>
                  <paper-row>
                    <paper-cell>[[getSub(companies, changeItem.company, 'name')]]</paper-cell>
                    <paper-cell>
                      <katapult-switcher
                        style="height: 32px; font-size: 14px; text-transform: uppercase;"
                        items="[[permissionLevels]]"
                        value="[[changeItem.permission]]"
                        data-path="item.sharing_changes.$(model.changeItem.$key).permission"
                        on-input="updateProperty"
                      ></katapult-switcher>
                    </paper-cell>
                    <paper-cell icon-button>
                      <katapult-button
                        iconOnly
                        noBorder
                        icon="delete"
                        data-path="item.sharing_changes.$(model.changeItem.$key)"
                        data-value="$null"
                        on-click="updateProperty"
                      ></katapult-button>
                    </paper-cell>
                  </paper-row>
                </template>
                <!-- Add Drop Down -->
                <paper-row>
                  <paper-cell>
                    <katapult-drop-down
                      label="Select a Company"
                      no-label-float
                      items="[[companies]]"
                      value-path="$key"
                      label-path="name"
                      on-selected-changed="addSharingChange"
                    ></katapult-drop-down>
                  </paper-cell>
                </paper-row>
              </paper-table>
            </paper-cell>
          </paper-row>
        </template>

        <!-- SET_TIMELINE -->
        <template is="dom-if" if="[[equal(item.action, 'SET_TIMELINE')]]" restamp>
          <!-- Timeline -->
          <paper-row input>
            <paper-cell icon>
              <material-icon icon="timeline"></material-icon>
            </paper-cell>
            <paper-cell shrink>Timeline</paper-cell>
            <paper-cell>
              <katapult-drop-down
                label="Timeline"
                value="[[item.timeline_to_set]]"
                value-path="key"
                label-path="label"
                items="[[timelineModelsList]]"
                no-label-float
                data-path="item.timeline_to_set"
                on-selected-changed="updateProperty"
              ></katapult-drop-down>
            </paper-cell>
          </paper-row>
        </template>
      `;
    }

    static get properties() {
      return {
        item: { type: Object, notify: true },
        appType: Object,
        exportOptions: Object,
        otherAttributes: Object,
        permissionLevels: { type: Array },
        companies: { type: Object },
        timelineModels: { type: Object },
        timelineModelsList: {
          type: Array,
          computed: '_computeTimelineModelsList(timelineModels)'
        },
        userGroup: { type: String }
      };
    }

    static get observers() {
      return [`calcAttributeInputEditor(item.action, item.attribute)`, `setDefaultIdGenerationMethod(item.action)`];
    }

    constructor() {
      super();
      this.permissionLevels = ['applicant', 'read', 'write'];
      this.startsWith = (x, y) => x?.startsWith?.(y);
      this._isJobAttribute = (x) => x.attribute_types?.includes?.('job');
      this._klogicSchemas = {
        setMetadata: {
          job: {
            $key: 'text',
            $path: 'text',
            nodes: DEFAULT_SCHEMAS.JOB.nodes,
            metadata: DEFAULT_SCHEMAS.JOB.metadata,
            files: 'object',
            sharing: DEFAULT_SCHEMAS.JOB.sharing,
            name: DEFAULT_SCHEMAS.JOB.name,
            jobOwner: 'text',
            timers: 'object'
          },
          appType: 'object',
          appAttachType: 'object',
          currentStatus: 'object',
          user: 'object',
          userHasUtilityPermission: 'boolean',
          userGroup: 'text',
          utilityCompany: 'text',
          attacher: { name: 'text' },
          attacherSettings: { custom_pole_limit: 'number', labels: 'list', utility_admins: 'list' },
          lookupIdsInOtherActiveApps: 'object',
          lookupIdsInOwnActiveApps: 'object',
          existingTakeOffAttachments: 'object',
          submissionEntryDetails: PORTAL_SCHEMAS.SUBMISSION_ENTRY_DETAILS,
          portalUserOptions: 'object'
        }
      };
    }

    calcAttributeInputEditor() {
      let editorType = null;
      if (this.item.action == 'SET_METADATA') {
        const guiElement = this.otherAttributes?.[this.item.attribute]?.gui_element;
        if (['textbox', 'date', 'user-dropdown', undefined].includes(guiElement)) editorType = 'k-logic-editor';
        else editorType = 'input-element';
      }
      this.attributeInputEditor = editorType;
    }

    setDefaultIdGenerationMethod() {
      if (this.item.action != 'SET_APP_NUMBER') return;
      if (this.item.generation_method == null)
        this.updateProperty(new CustomEvent('add-item', { detail: { path: `item.generation_method`, value: 'use_default_identifier' } }));
    }

    addSharingChange(e) {
      if (e?.detail?.value !== '' && e?.detail?.value != null) {
        const path = `item.sharing_changes.${GeneratePushID()}`;
        this.updateProperty(new CustomEvent('add-item', { detail: { path, value: { company: e.detail.value, permission: 'read' } } }));
        e.currentTarget.clear();
      }
    }

    getAttributeModel(attributeName) {
      const model = this.otherAttributes?.[attributeName];
      if (!model) return {};

      // Make sure the model is not read only.
      return { ...model, read_only: false };
    }

    _computeTimelineModelsList(timelineModels) {
      const allTimelineModelsList = Object.entries(timelineModels ?? {}).filter(([, model]) => !model.hidden);
      // Get the simple timeline models (models that don't have sub-models)
      const simpleTimelineModelsList = allTimelineModelsList
        .filter(([, model]) => model.models == null)
        .map(([key, model]) => ({ key, label: /** @type {string} */ (model.name) }));

      // Flatten timeline models with sub-models (and sub-sub-models)
      const nestedTimelineModelsList = allTimelineModelsList.filter(([, model]) => model.models != null);
      for (const [modelKey, model] of nestedTimelineModelsList) {
        // Get the sub-models of the current model
        const subModels = Object.entries(model.models);
        for (const [subModelKey, subModel] of subModels) {
          // Skip over hidden sub-models
          if (subModel.hidden) continue;

          // Get the sub-sub-models of the current sub-model
          const subSubModels = Object.entries(subModel.models ?? {}).map(([subSubKey, subSubModel]) => ({
            key: `${modelKey}.models.${subModelKey}.models.${subSubKey}`,
            label: `${model.name} - ${subModel.name} - ${subSubModel.name}`
          }));

          // Add the sub-sub-models to the simple timeline models list
          simpleTimelineModelsList.push(...subSubModels);
          // For complex models, add one additional option for "auto" (existing behavior)
          simpleTimelineModelsList.push({
            key: `${modelKey}.models.${subModelKey}.models.__auto__`,
            label: `${model.name} - ${subModel.name} (Auto)`
          });
        }
      }

      return simpleTimelineModelsList;
    }
  }
);
